import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.config({
  ignoreMobileResize: true,
});

let refreshRaf = 0;

/** Debounced refresh — avoids layout thrash when many components mount */
export const scheduleScrollRefresh = () => {
  if (refreshRaf) return;
  refreshRaf = requestAnimationFrame(() => {
    refreshRaf = 0;
    ScrollTrigger.refresh();
  });
};

/** Use after pin / scrub setup — must run synchronously, not debounced */
export const refreshScrollTriggers = () => {
  ScrollTrigger.refresh();
};

export { gsap, ScrollTrigger };
